/**
 * Static video gallery entries and YouTube URL helpers.
 * Replace IDs and captions when wiring to CMS or your official channel.
 */

export type ShortVideo = {
  id: string;
};

export type GalleryVideo = {
  id: string;
  caption: string;
};

export const shortsItems: ShortVideo[] = [
  { id: 'dQw4w9WgXcQ' },
  { id: 'jNQXAC9IVRw' },
  { id: '9bZkp7q19f0' },
  { id: 'kJQP7kiw5Fk' },
  { id: 'L_jWHffIx5E' },
];

export const latestVideos: GalleryVideo[] = [
  {
    id: 'y6120QOlsfU',
    caption: 'Wonder Cement | Amitabh Bachchan | Farq Nazar Aayega | 2023 | 30 Seconds',
  },
  {
    id: 'OPf0YbXqDm0',
    caption: 'Wonder Champions 2024 Bangkok',
  },
  {
    id: 'JGwWNGJdfx4',
    caption: 'Robotic Technology for Quality Check & Correction at Wonder Cement',
  },
  {
    id: 'dQw4w9WgXcQ',
    caption: 'Plant tour: Nimbhera — sustainable cement production',
  },
  {
    id: 'jNQXAC9IVRw',
    caption: 'CSR initiative: building stronger communities across Rajasthan',
  },
  {
    id: '9bZkp7q19f0',
    caption: 'Wonder Plus — strength that lasts for generations',
  },
  {
    id: 'kJQP7kiw5Fk',
    caption: 'Corporate film: the journey of Wonder Cement',
  },
  {
    id: 'L_jWHffIx5E',
    caption: 'Safety first: training and culture at our plants',
  },
  {
    id: 'J---aiyznGQ',
    caption: 'Customer stories: from foundation to finishing',
  },
];

export type YoutubeThumbnailQuality =
  | 'mqdefault'
  | 'hqdefault'
  | 'sddefault'
  | 'maxresdefault'
  | 'oar2';

export function youtubeThumbnailUrl(
  videoId: string,
  quality: YoutubeThumbnailQuality = 'hqdefault',
) {
  return `https://i.ytimg.com/vi/${videoId}/${quality}.jpg`;
}

/** Vertical/original-aspect thumbnail — best for YouTube Shorts cards. */
export function youtubeShortsThumbnailUrl(videoId: string) {
  return youtubeThumbnailUrl(videoId, 'oar2');
}

export function youtubeWatchUrl(videoId: string) {
  return `https://www.youtube.com/watch?v=${videoId}`;
}

export function youtubeShortsUrl(videoId: string) {
  return `https://www.youtube.com/shorts/${videoId}`;
}
